<template>
    <div class="blacklistDisposal wrap">
        <div class="wrapper-box" :id="'black-'+index" v-for="(item,index) in blackList" :key="'black-' + index">
            <div class="info-box">
                <div class="title">{{item.listState === 'new'?'黑名单监管中' : '退出黑名单监管'}}</div>
                <div class="date-box">
                    <div
                        class="starttime"
                    >{{item.createTime}} {{item.listState === 'new' ? '开始' : ''}}</div>
                    <div class="endtime" v-if="item.recordState === 1">剩余{{item.leftTime}}</div>
                </div>
            </div>
            <rline></rline>
            <listItem
                :label="item.listState === 'new' ?'纳入原因': '退出原因'"
                :labelWidth="72"
                :ctnColor="'#333333'"
                :showRight="false"
            >{{item.disposeTypeDetail || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
                :label="'处理单位'"
                :labelWidth="72"
                :ctnColor="'#333333'"
                :showRight="false"
            >{{item.dept || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
                :label="'处理人员'"
                :labelWidth="72"
                :ctnColor="'#333333'"
                :showRight="false"
            >{{item.creatorName || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
                :label="'备注'"
                :labelWidth="72"
                :ctnColor="'#333333'"
                :showRight="false"
            >{{item.desc === '' ? '暂无信息' :item.desc}}</listItem>
            <rline v-if="item.attachList.length > 0"></rline>
            <div
                v-if="item.attachList && item.attachList.length > 0"
                @click="onDialogOpen(item.attachList)"
            >
                <listItem :label="'附件'" :labelWidth="72" :ctnColor="'#333333'"></listItem>
            </div>
        </div>

        <div
            class="wrapper-box spa-wrapper-box"
            :id="'discipline-'+index"
            v-for="(item,index) in discipline"
            :key="'discipline-' + index "
        >
            <div class="info-box">
                <div class="title" v-if="item.optionType === 0">{{item.disciplineTypeName}}中</div>
                 <div class="title" v-if="item.optionType === 1">退出惩戒</div>
                <div class="date-box" v-if="item.optionType === 0">
                    <div class="starttime">{{item.disciplineDate}} 开始</div>
                    <div class="endtime">剩余{{item.leftTime}}</div>
                </div>
                <div class="date-box" v-if="item.optionType === 1">
                    <div class="starttime">{{item.disciplineDate}} 退出</div>
                </div>
            </div>
            <rline></rline>
            <listItem
                v-if="item.optionType !== 1"
                :label="'纳入原因'"
                :labelWidth="72"
                :ctnColor="'#333333'"
                :showRight="false"
            >{{item.disciplineTypeName}}</listItem>
            <rline></rline>
            <listItem
                :label="'处理单位'"
                :labelWidth="72"
                :ctnColor="'#333333'"
                :showRight="false"
            >{{item.disposeDept || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
                :label="'处理人员'"
                :labelWidth="72"
                :ctnColor="'#333333'"
                :showRight="false"
            >{{item.creatorName || '暂无信息'}}</listItem>
            <rline></rline>
            <listItem
                :label="'备注'"
                :labelWidth="72"
                :ctnColor="'#333333'"
                :showRight="false"
            >{{item.disciplineDesc === '' ? '暂无信息' :item.disciplineDesc}}</listItem>
            <rline></rline>
            <div
                v-if="item.attachList && item.attachList.length > 0"
                @click="onDialogOpen(item.attachList)"
            >
            <listItem :label="'附件'" :labelWidth="72" :ctnColor="'#333333'"></listItem>
            </div>
        </div>
        <empty :type="3" v-if="blackList.length === 0 && !isLoading"></empty>
        <!-- 延长黑名单和退出黑名单 -->
        <!-- <betterScroll class="check_btn" :scrollX='true' v-if="showType1&&showType"> -->
            <!-- <betterScroll class="check_btn" :scrollX='true' v-if="isTpyeName.roleName=='marketRegulationTravel-1'"> -->
                <betterScroll class="check_btn" :scrollX='true' v-if="isTpyeName.OrgInfo.orgRegionId=='34'||(isTpyeName.roleName=='marketRegulationTravel-1'&&guideBlackId!=0)">
         <!-- <betterScroll class="check_btn" :scrollX='true'> -->
             <div class="wrapper">
                    <!-- <span @click="$router.push({path:`/guide/guiding?type=${'addAllBlacklist'}&guideId=${guideId}`})" v-if="showType1">+ 黑名单惩戒</span> -->
                    <span @click="$router.push({path:`/guide/guiding?type=${'addAllBlacklist'}&guideId=${guideId}&guideBlackId=${guideBlackId}`})" v-if="isTpyeName.OrgInfo.orgRegionId=='34'&&!disciplineType">+ 黑名单惩戒</span>
                    <span @click="goBlackList"  v-if="isTpyeName.roleName=='marketRegulationTravel-1'&&guideBlackId!=0">退出黑名单</span>
                    <!-- <span @click="$router.push({path:`/guide/guiding?type=${'longBlacklist'}&guideId=${guideId}`})"  v-if="showType">延长黑名单</span> -->
                    <span @click="$router.push({path:`/guide/guiding?type=${'longBlacklist'}&guideId=${guideId}`})" v-if="isTpyeName.roleName=='marketRegulationTravel-1'&&guideBlackId!=0">延长黑名单</span>
                    <!-- <span @click="$router.push({path:'/guide/exitBlackList', query:{type:'quiteAllBlacklist','guideBlackId':guideBlackId}})" v-if="showType1">退出全国惩戒</span> -->
                    <span @click="$router.push({path:'/guide/exitBlackList', query:{type:'quiteAllBlacklist','guideBlackId':guideBlackId,'guideId':guideId}})" v-if="isTpyeName.OrgInfo.orgRegionId=='34'&&disciplineType === 'national'">退出全国惩戒</span>
                    <span @click="$router.push({path:'/guide/exitBlackList', query:{type:'quiteAllBlacklistCity','guideBlackId':guideBlackId,'guideId':guideId}})" v-if="isTpyeName.OrgInfo.orgRegionId=='34'&&disciplineType === 'provincial'">退出全省惩戒</span>
                    <!-- <span @click="$router.push({path:`/guide/guiding?type=longAllBlacklist&guideId=${guideBlackId}`})" v-if="showType1">延长全国惩戒</span> -->
                    <span @click="$router.push({path:`/guide/guiding?type=longAllBlacklist&guideId=${guideId}&guideBlackId=${guideBlackId}&disciplineType=national`})" v-if="isTpyeName.OrgInfo.orgRegionId=='34'&&disciplineType === 'national'">延长全国惩戒</span>
                    <span @click="$router.push({path:`/guide/guiding?type=longAllBlacklistCity&guideId=${guideId}&guideBlackId=${guideBlackId}&disciplineType=provincial`})" v-if="isTpyeName.OrgInfo.orgRegionId=='34'&&disciplineType === 'provincial'">延长全省惩戒</span>
                    <!-- <span @click="$router.push({path:`/guide/guiding?type=${'addAllBlacklist'}&guideId=${guideId}`})" v-if="true">+ 黑名单惩戒</span>
                    <span @click="$router.push({path:`/guide/exitBlackList?type=${'quiteBlacklist'}&guideId=${guideId}`})"  v-if="true">退出黑名单</span>
                    <span @click="$router.push({path:`/guide/guiding?type=${'longBlacklist'}&guideId=${guideId}`})"  v-if="true">延长黑名单</span>
                    <span @click="$router.push({path:'/guide/exitBlackList', query:{type:'quiteAllBlacklist','guideBlackId':guideBlackId}})" v-if="true">退出全国惩戒</span>
                    <span @click="$router.push({path:`/guide/guiding?type=longAllBlacklist&guideId=${guideBlackId}`})" v-if="true">延长全国惩戒</span> -->
             </div>
        </betterScroll>
    </div>
</template>
<script>
    import empty from 'comps/empty';
    import api from '../../service/modules/guide';
    import listItem from '../travelAgency/components/list-itemone';
    import rline from '../travelAgency/components/line';
    import { ImagePreview } from 'vant';
    import apimessage from '../../service/modules/message'
    import betterScroll from '../../components/base/betterScroll.vue'
    export default {
        components: {
            rline,
            listItem,
            empty,
            betterScroll
        },

        data () {
            return {
                guideId: 0,
                blackList: [],
                discipline: [],
                isLoading: true,
                type: '',
                index: '',
                guideBlackId: 0,
                showType: false,
                showType1: false,
                disciplineType: this.$route.query.disciplineType,
                isTpyeName: JSON.parse(localStorage.getItem('guideInfoObj'))
            };
        },

        computed: {

        },

        watch: {},

        methods: {
            test () {},
            goBlackList () {
                if (!this.disciplineType) {
                    this.$router.push({ path: `/guide/exitBlackList?type=${'quiteBlacklist'}&guideId=${this.guideId}` })
                } else {
                    this.$Toast('请先退出黑名单惩戒');
                }
            },
            myPending (index) {
                this.currentIndex = index;
            },
            // 导游黑名单监管信息拉取
            getBlacklistMessage () {
                api.getBlacklistMessage({ guideId: this.guideId }).then(res => {
                    this.isLoading = false;
                    if (res.ret === 0) {
                        this.blackList = res.data.blacklist;
                        this.discipline = res.data.discipline;

                        this.$nextTick(() => {
                            let index = 0
                            // 黑名单
                            if (Number(this.type) === 1) {
                                this.blackList.forEach((item, idx) => {
                                    if (item.id === this.id) {
                                        index = idx
                                    }
                                })
                                document.querySelector('.wrap').scrollTo({
                                    top: document.querySelector('#black-' + index).offsetTop - 10

                                });
                            // 惩戒
                            } else if (Number(this.type) === 2) {
                                this.discipline.forEach((item, idx) => {
                                    if (item.id === this.id) {
                                        index = idx
                                    }
                                })
                                document.querySelector('.wrap').scrollTo({
                                    top: document.querySelector('#discipline-' + index).offsetTop - 10
                                });
                            }
                        })
                    }
                });
            },
            onDialogOpen (attachList) {
                let photos = [];
                attachList.forEach(element => {
                    photos.push(element.accthPath);
                });
                let credentialsPhoto = [{ name: '附件', photos: photos }];
                console.log(credentialsPhoto)
                localStorage.setItem('credentialsPhoto', JSON.stringify(credentialsPhoto))
                // return
                this.$router.push({
                    path: '/guide/photo'
                    // query: { credentialsPhoto: JSON.stringify(credentialsPhoto) }
                });
            },
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            }
        },

        mounted () {
            this.guideId = this.$route.query.guideId || ''
            this.guideBlackId = this.$route.query.guideBlackId || ''
            this.disciplineType = this.$route.query.disciplineType
            // alert(this.guideBlackId);
            this.type = this.$route.query.type || ''
            this.id = this.$route.query.id || ''
            this.getBlacklistMessage();
        },
        created () {
            let messageId = this.$route.query.messageId || ''
            let isRead = this.$route.query.isRead || 'true'
            this.onMessageReadOne(isRead, messageId)
            let isTpyeName = JSON.parse(localStorage.getItem('guideInfoObj')).OrgInfo.orgRegionId
            if (isTpyeName === '34') {
                this.showType1 = true
            } else if (isTpyeName !== '34') {
                this.showType = true
            }
        }
    };
</script>
<style scoped lang="less">
.blacklistDisposal {
     width: 100%;
     height: 100%;
     overflow: auto;
     background-color: #FBFBFB;
    .backnav-box {
        height: 44px;
        background: rgba(54, 179, 116, 1);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .back-icon {
            position: absolute;
            width: 10px;
            height: 16px;
            top: 14px;
            left: 20px;
        }
        .backnav-text {
            font-size: 16px;

            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 16px;
        }
    }
    .wrapper-box {
        width: 351px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin: 16px 12px 0 12px;

        .info-box {
            box-sizing: border-box;
            padding: 16px;

            .title {
                font-size: 14px;

                font-family: PingFang SC, Arial, sans-serif;
                -webkit-font-smoothing: antialiased;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                line-height: 14px;
                margin-bottom: 7px;
            }
            .date-box {
                height: 14px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .starttime,
                .endtime {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    line-height: 14px;
                }
            }
        }
    }
    .spa-wrapper-box {
        margin-top: 12px;
    }
    .check_btn{
        width:100%;
        height:50px;
        background-color: #fff;
        position:fixed;
        left:0;
        bottom:0;
        // display: flex;
        // flex-direction: row-reverse;
        // align-items: center;
        // padding:0 12px;
        // box-sizing: border-box;
        .wrapper{
            white-space:nowrap;
            position:absolute;
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            padding:0 12px;
            box-sizing: border-box;
            height:50px;
            span{
                display: inline-block;
                padding:8px 16px;
                border:1px solid #38B277;
                color:#38B277;
                border-radius: 2px;
                font-size:14px;
                margin-left:12px;
            }
        }

        // span:nth-child(1){
        //     margin-left:12px;
        // }
    }
}
</style>
